import { useState } from 'react'
import { useArchiveBillMutation, useSendBillToClientMutation, useVoidBillMutation } from '../../generated'
import { Alert } from '../components/common/Alert'

interface UseFundRequestActionsProps {
  onRefetch: () => void
  onClose: () => void
}

export const useFundRequestActions = ({ onRefetch, onClose }: UseFundRequestActionsProps) => {
  const [showVoidConfirmation, setShowVoidConfirmation] = useState(false)
  const [showRecordPaymentModal, setShowRecordPaymentModal] = useState(false)

  const [voidBill, { loading: voiding }] = useVoidBillMutation({
    onCompleted: data => {
      if (data?.voidBill?.response?.status === 200) {
        Alert.success('Bill voided successfully')
        setShowVoidConfirmation(false)
        onRefetch()
      }
    },
    onError: error => {
      Alert.error(error.message || 'Failed to void bill')
      setShowVoidConfirmation(false)
    }
  })

  const [archiveBill, { loading: archiving }] = useArchiveBillMutation({
    onCompleted: data => {
      if (data?.archiveBill?.response?.status === 200) {
        Alert.success('Bill archived successfully')
        onClose()
        onRefetch()
      }
    },
    onError: error => {
      Alert.error(error.message || 'Failed to archive bill')
    }
  })

  const [sendBillToClient, { loading: sendingToClient }] = useSendBillToClientMutation({
    onCompleted: data => {
      if (data?.sendBillToClient?.response?.status === 200) {
        Alert.success('Bill sent to client successfully')
        onClose()
        onRefetch()
      }
    },
    onError: error => {
      Alert.error(error.message || 'Failed to send bill to client')
    }
  })

  const handleVoidBill = (billId: number) => {
    voidBill({
      variables: {
        voidBillInput: {
          billId
        }
      }
    })
  }

  const handleArchiveBill = (billId: number) => {
    archiveBill({
      variables: { archiveBillInput: { billId } }
    })
  }

  const handleSendBillToClient = (billId: number) => {
    sendBillToClient({
      variables: { sendBillToClientInput: { billId } }
    })
  }

  return {
    // State
    showVoidConfirmation,
    setShowVoidConfirmation,
    showRecordPaymentModal,
    setShowRecordPaymentModal,
    voiding,
    archiving,
    sendingToClient,

    // Actions
    handleVoidBill,
    handleArchiveBill,
    handleSendBillToClient
  }
}
